import {horizontalFlipping} from "./horizontal-flipping";

document.addEventListener("DOMContentLoaded", function() {
    installSliderType7();
});

export function installSliderType7(){

    const $slider_node_type7 = $(".js-slider-type7");

    if($slider_node_type7.length){

        let slider = $slider_node_type7.owlCarousel({
            loop:false,
            margin:10,
            dots:true,
            items: 1,
            smartSpeed: 500,
        });

        slider.each(function(){

            const $el = $(this);

            horizontalFlipping($el);
        });

    }
}


